import { Route } from "components/utils";
import { NotFound } from "pages/notFound";
import { LoadingsList } from "pages/wms/loadingsList/LoadingsList";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

export const Loadings = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        component={LoadingsList}
        exact={true}
        path={`${match.path}/list/:tab`}
        title="Milo - WMS - załadunki"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
